// IE 11 Problem resolver
import 'babel-polyfill';
import 'react-app-polyfill/ie11';
// IE Problem resolver

import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import './index.css';
import './tag.css';

import App from './App';

const tagManagerArgs = {
  gtmId: 'GTM-TTCPNCR',
};
TagManager.initialize(tagManagerArgs);

ReactDOM.render(<App />, document.getElementById('root'));
